export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDkgMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS40ODYxOCA3LjM1MzMzTDAuMTkzNDgxIDIuMDYwNjRMMS42MDc2OSAwLjY0NjQyM0w4LjMxNDYgNy4zNTMzM0wxLjYwNzcgMTQuMDYwMkwwLjE5MzQ4MiAxMi42NDZMNS40ODYxOCA3LjM1MzMzWiIgZmlsbD0iIzAwQUVFRiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./images/chevron-right.svg
// module id = 111
// module chunks = 0